module.exports = function (nodeList) {
  return [].slice.call(nodeList);
};
